const MoveEvent = require('../events/MoveEvent');
const EventEmitter = require('eventemitter3');
const { logError } = require('../logger');

const Move = function (battleState) {
  this.handle = 'move';
  this.physical = true;
  this.movement = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.tile && victim.occupied === false;
  };

  this.execute = (actor, victim) => {
    actor = battleState?.allPieces[actor?.uid];
    victim = battleState?.allPieces[victim?.uid];
    if (!actor || !actor.inPlay || !victim) {
      return;
    }

    try {
      var result = {};
      result.oldTileId = battleState.getTileAtCoords(actor.x, actor.y).uid;

      const moveEvent = new MoveEvent(battleState, actor.uid);
      moveEvent.execute(victim);

      // result
      result.moveEvent = moveEvent;
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Move',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = Move;
